import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["eventData"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import { GoogleAnalytics } from '../../../services/analytics';
import { FISHERMAN_BOT_EVENT } from '../../../services/analytics/google/google-analytics.constants';
export function getEventType(botpressEvent) {
  var standardEventType = _get(botpressEvent, 'type');
  var customEventType = _get(botpressEvent, 'payload.eventType');
  return customEventType || standardEventType;
}
export function processGoogleAnalyticsEvent(botpressEvent) {
  var _get2 = _get(botpressEvent, 'payload', {}),
    _get2$eventData = _get2.eventData,
    eventData = _get2$eventData === void 0 ? {} : _get2$eventData,
    extraEventData = _objectWithoutProperties(_get2, _excluded);
  var category = eventData.category,
    action = eventData.action,
    _eventData$label = eventData.label,
    label = _eventData$label === void 0 ? '' : _eventData$label,
    value = eventData.value;
  GoogleAnalytics.event(category, action, _objectSpread({
    eventType: FISHERMAN_BOT_EVENT,
    label: label,
    value: value
  }, extraEventData));
}